<template>
  <div class="sidebar-menu" @mouseleave="activeCategory = null">
    <div class="menu-header">
      <h3>全部商品分类</h3>
    </div>
    
    <div class="menu-scroll-wrapper">
      <ul class="menu-list">
        <li v-for="(category, index) in categories" :key="index" class="menu-item" 
            :class="{ active: activeCategory === index }"
            @mouseenter="activeCategory = index">
          <div class="item-content">
            <img :src="category.image || 'https://image3.vipmro.net//saleCateGoryImg/2c377427-dd83-424d-b355-a23e5123d4b3.jpg'" class="cat-icon" alt="icon">
            <span class="cat-name">{{ category.name }}</span>
            <span class="arrow">&gt;</span>
          </div>
        </li>
      </ul>
    </div>

    <!-- Mega Menu (Outside the scrollable list) -->
    <div class="mega-menu" v-if="activeCategory !== null">
      <div class="menu-main">
        <div class="sub-section" v-for="(subGroup, subIndex) in categories[activeCategory].subGroups" :key="subIndex">
          <div class="sub-title">
            <img v-if="subGroup.image" :src="subGroup.image" class="sub-icon" alt="icon">
            {{ subGroup.title }}
          </div>
          <div class="sub-items">
            <div class="sub-item" v-for="(item, itemIndex) in subGroup.items" :key="itemIndex" @click="handleSearch(null, item.id)">
              <div class="item-img">
                <img :src="item.image" :alt="item.name">
              </div>
              <div class="item-name">{{ item.name }}</div>
            </div>
          </div>
        </div>
        <div v-if="categories[activeCategory].subGroups.length === 0" class="empty-tip">
          暂无分类数据
        </div>
      </div>
      <div class="menu-brands" v-if="categories[activeCategory].brands.length > 0">
        <div class="brand-title">推荐品牌</div>
        <div class="brands-grid">
          <div class="brand-item" v-for="(brand, brandIndex) in categories[activeCategory].brands" :key="brandIndex" @click="handleSearch(null, categories[activeCategory].id, brand.id)">
            <img :src="brand.logo" :alt="brand.name">
          </div>
        </div>
        <!-- <div class="activity-link">
          <router-link to="/activity/huixiang">进入惠象品牌专区 >></router-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryList } from '@/api/category'

export default {
  name: 'SidebarMenu',
  data() {
    return {
      activeCategory: null,
      categories: [],
      categoryMap: {} // 存储所有分类的映射，方便查找
    }
  },
  mounted() {
    this.fetchCategories()
  },
  methods: {
    async fetchCategories() {
      try {
        const res = await getCategoryList()
        if (res.code === 200 && res.rows) {
          this.buildCategoryTree(res.rows)
        }
      } catch (error) {
        console.error('获取分类失败:', error)
      }
    },
    // 构建分类树
    buildCategoryTree(list) {
      // 先建立 id -> item 的映射
      const map = {}
      list.forEach(item => {
        map[item.id] = { ...item, children: [] }
      })
      this.categoryMap = map
      
      // 找出顶级分类（pid === 0）
      const topCategories = list.filter(item => item.pid === 0)
      
      // 为每个顶级分类构建子分类
      this.categories = topCategories.map(topCat => {
        // 获取直接子分类（pid === topCat.id）
        const directChildren = list.filter(item => item.pid === topCat.id)
        
        // 构建 subGroups
        const subGroups = directChildren.map(child => {
          // 获取该子分类下的三级分类
          const thirdLevel = list.filter(item => item.pid === child.id)
          
          return {
            title: child.name,
            image: child.picture || child.image,
            items: thirdLevel.map(item => ({
              id: item.id,
              name: item.name,
              image: item.picture || 'https://image3.vipmro.net//saleCateGoryImg/2c377427-dd83-424d-b355-a23e5123d4b3.jpg'
            }))
          }
        })
        
        // 处理品牌
        const brands = (topCat.brandList || []).map(brand => ({
          id: brand.brandId,
          name: brand.brandName,
          logo: brand.brandLogo
        }))
        
        return {
          id: topCat.id,
          name: topCat.name,
          image: topCat.picture || topCat.image,
          subGroups,
          brands
        }
      })
    },
    handleSearch(keyword, categoryId, brandId) {
      const query = {}
      if (keyword) query.keyword = keyword
      if (categoryId) query.categoryId = categoryId
      if (brandId) query.brandId = brandId
      
      this.$router.push({
        path: '/list',
        query: query
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-menu {
  width: 210px;
  height: 480px;
  position: relative;
  z-index: 100;
  background: white;
  border-radius: 8px 0 0 8px;
  box-shadow: 2px 0 10px rgba(0,0,0,0.02);

  .menu-header {
    background-color: #d97706;
    color: #fff;
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    display: none; 
  }

  .menu-scroll-wrapper {
    height: 100%;
    overflow-y: auto;
    background-color: #fff;
    border-radius: 8px 0 0 8px;

    /* Custom Scrollbar Styling */
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-track {
      background-color: #fff;
    }
  }

  .menu-list {
    padding: 10px 0;
    
    .menu-item {
      height: 42px;
      line-height: 42px;
      padding: 0 16px;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;
      color: #374151;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;

      .item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .cat-icon {
          width: 20px;
          height: 20px;
          margin-right: 12px;
          object-fit: contain;
          transition: all 0.3s;
          opacity: 0.7;
        }

        .cat-name {
          flex: 1;
        }

        .arrow {
          font-family: consolas;
          color: #d1d5db;
          font-size: 12px;
          transition: all 0.3s;
        }
      }

      &:hover, &.active {
        background: rgba(217, 119, 6, 0.04);
        color: #d97706;
        font-weight: 600;
        
        &::after {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 3px;
          height: 18px;
          background-color: #d97706;
          border-radius: 0 4px 4px 0;
        }
        
        .cat-icon { opacity: 1; transform: scale(1.1); }
        .arrow { color: #d97706; transform: translateX(4px); }
      }
    }
  }

  .mega-menu {
    position: absolute;
    left: 210px;
    top: 0;
    width: 1000px;
    height: 480px;
    background-color: #fff;
    box-shadow: 30px 0 60px rgba(0,0,0,0.1);
    z-index: 200;
    display: flex;
    overflow: hidden;
    border-radius: 0 12px 12px 0;
    background: linear-gradient(to right, #ffffff, #fafafa);
    border: 1px solid #f3f4f6;
    border-left: none;
    animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);

    .menu-main {
      flex: 1;
      padding: 20px;
      height: 100%; /* Full height */
      overflow-y: auto; /* Enable scrolling */
      
      /* Custom Scrollbar */
      &::-webkit-scrollbar {
        width: 6px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ccc;
        border-radius: 3px;
      }
      &::-webkit-scrollbar-track {
        background-color: #fff;
      }

      .sub-section {
        margin-bottom: 30px;
        
        .sub-title {
          font-weight: 800;
          font-size: 14px;
          color: #111827;
          margin-bottom: 20px;
          display: flex;
          align-items: center;
          
          .sub-icon {
            width: 18px;
            height: 18px;
            margin-right: 8px;
            object-fit: contain;
          }
        }

        .sub-items {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
          gap: 16px;

          .sub-item {
            padding: 12px;
            background: #fff;
            border-radius: 8px;
            border: 1px solid transparent;
            transition: all 0.3s;
            text-align: center;
            
            &:hover {
              border-color: #fed7aa;
              box-shadow: 0 4px 12px rgba(217, 119, 6, 0.08);
              transform: translateY(-2px);
              
              .item-name { color: #d97706; }
            }

            .item-img {
              width: 54px;
              height: 54px;
              margin: 0 auto 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              
              img {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
                filter: grayscale(0.2);
                transition: filter 0.3s;
              }
            }
            
            &:hover .item-img img { filter: grayscale(0); }

            .item-name {
              font-size: 12px;
              color: #4b5563;
              font-weight: 500;
              line-height: 1.4;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }
          }
        }
      }
      
      .empty-tip {
        color: #999;
        padding: 20px;
      }
    }

    .menu-brands {
      width: 280px;
      background-color: #fcfcfc;
      border-left: 1px solid #f1f5f9;
      padding: 24px 16px;
      height: 100%;
      overflow-y: auto;
      
      .brand-title {
        font-size: 14px;
        font-weight: 700;
        color: #374151;
        margin-bottom: 16px;
        padding-left: 8px;
      }

      .brands-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
      }

      .brand-item {
        height: 54px;
        background-color: #fff;
        border: 1px solid #f1f5f9;
        border-radius: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        padding: 6px;
        cursor: pointer;
        
        &:hover {
          border-color: #d97706;
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          transform: translateY(-1px);
        }
        
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          transition: all 0.3s;
        }

        &:hover img {
          transform: scale(1.05);
        }
      }

      .activity-link {
        width: 100%;
        margin-top: 24px;
        
        a {
          display: block;
          padding: 12px;
          background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
          color: #fff;
          font-weight: 600;
          font-size: 13px;
          text-decoration: none;
          border-radius: 8px;
          text-align: center;
          transition: all 0.3s;
          box-shadow: 0 4px 12px rgba(217, 119, 6, 0.2);
          
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(217, 119, 6, 0.3);
          }
        }
      }
    }
  }
}

// 响应式适配 - 平板到PC端
@media (max-width: 1399px) and (min-width: 1200px) {
  .sidebar-menu {
    height: 420px;
    .mega-menu {
      width: 970px;
      height: 420px;
    }
  }
}

@media (max-width: 1199px) and (min-width: 992px) {
  .sidebar-menu {
    width: 180px;
    height: 380px;
    .mega-menu {
      left: 180px;
      width: 790px;
      height: 380px;
    }
    .menu-list .menu-item {
      height: 35px;
      line-height: 35px;
      font-size: 13px;
    }
  }
}

@media (max-width: 991px) and (min-width: 768px) {
  .sidebar-menu {
    display: none; // 平板竖屏时隐藏侧边栏
  }
}
@keyframes slideIn {
  from { opacity: 0; transform: translateX(10px); }
  to { opacity: 1; transform: translateX(0); }
}
</style>
